import { Organization, Product } from '@shared/generated/graphql';

export function hasChatsAccess({
  hasVee,
  isVoomaAdmin,
}: {
  hasVee: boolean;
  isVoomaAdmin: boolean;
}): boolean {
  return hasVee || isVoomaAdmin;
}

export function hasProducts(organizationDetails: Organization[]) {
  return {
    hasOrders: Boolean(
      organizationDetails.find((org) => org.products.includes(Product.ORDERS))
    ),
    hasQuotes: Boolean(
      organizationDetails.find((org) => org.products.includes(Product.QUOTES))
    ),
    hasEmailScanning: Boolean(
      organizationDetails.find((org) =>
        org.products.includes(Product.EMAIL_SCANNING)
      )
    ),
    hasWorkers: Boolean(
      organizationDetails.find((org) => org.products.includes(Product.WORKERS))
    ),
    hasCalls: Boolean(
      organizationDetails.find((org) => org.products.includes(Product.CALLS))
    ),
    hasCover: Boolean(
      organizationDetails.find((org) => org.products.includes(Product.COVER))
    ),
    hasSchedule: Boolean(
      organizationDetails.find((org) => org.products.includes(Product.SCHEDULE))
    ),
    hasTrack: Boolean(
      organizationDetails.find((org) => org.products.includes(Product.TRACK))
    ),
    hasVee: Boolean(
      organizationDetails.find((org) => org.products.includes(Product.VEE))
    ),
  };
}
